import { initializeApp } from "firebase/app"
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"
import { getAuth } from "firebase/auth"

const firebaseConfig = {
  apiKey: "AIzaSyBxV73r8gxFlb_Z64keNGzsLHQCwKNyOMg",
  authDomain: "bookfair-infobox-qr.firebaseapp.com",
  projectId: "bookfair-infobox-qr",
  storageBucket: "bookfair-infobox-qr.firebasestorage.app",
  messagingSenderId: "668011723710",
  appId: "1:668011723710:web:b1c28b2f00bd83ade1d7ef",
  measurementId: "G-N94BL30HKN"
}

const app = initializeApp(firebaseConfig)
export const storage = getStorage(app)
export const db = getFirestore(app)
export const auth = getAuth(app)
